import type { UnknownAction } from 'redux';

import { resourceUpserters } from '../core';
import * as actions from './accountsBalancesActions';
import {
  type AccountsBalanceProps,
  type AccountsBalancesStore,
  mkAccountsBalancesStore,
} from './accountsBalancesTypes';

const initialState = mkAccountsBalancesStore();

function accountsBalancesReducer(
  state: AccountsBalancesStore = initialState,
  action: UnknownAction,
): AccountsBalancesStore {
  switch (true) {
    case actions.getAccountsBalances.match(action):
      return state.set('isLoading', true);
    case actions.getAccountsBalancesSuccess.match(action):
      return resourceUpserters.upsertResources(state, action.payload);
    case actions.getAccountsBalancesFailure.match(action):
      return resourceUpserters.completeWithError<AccountsBalanceProps>(state, action.payload);
    case actions.batchAccountsBalances.match(action):
    case actions.batchAccountsBalancesSuccess.match(action):
      return resourceUpserters.upsertResources(state, { resources: action.payload });
    case actions.batchAccountsBalancesFailure.match(action):
      return resourceUpserters.resetResources<AccountsBalanceProps>(state, action.payload);
    default:
      return state;
  }
}

export default accountsBalancesReducer;
